import { Direction } from "../../constants/schema.js";
//#region src/utils/draw-relationship/stub.ts
function stubFor(slot) {
	return 24 + slot % 4 * 8;
}
function facingGap(start, end) {
	if (start.tableId === end.tableId) return null;
	if (start.direction === Direction.right && end.direction === Direction.left) return end.x - start.x;
	if (start.direction === Direction.left && end.direction === Direction.right) return start.x - end.x;
	if (start.direction === Direction.bottom && end.direction === Direction.top) return end.y - start.y;
	if (start.direction === Direction.top && end.direction === Direction.bottom) return start.y - end.y;
	return null;
}
function clampStub(stub, gap) {
	if (gap === null || gap <= 0) return stub;
	return Math.max(24, Math.min(stub, gap / 2 - 1));
}
function isHorizontal(direction) {
	return direction === Direction.left || direction === Direction.right;
}
function outwardSign(direction) {
	return direction === Direction.right || direction === Direction.bottom ? 1 : -1;
}
function offsetFrom(point, direction, distance) {
	const sign = outwardSign(direction);
	return isHorizontal(direction) ? {
		x: point.x + sign * distance,
		y: point.y
	} : {
		x: point.x,
		y: point.y + sign * distance
	};
}
function stubEnds({ start, end }, [startSlot, endSlot]) {
	const gap = facingGap(start, end);
	const startStub = clampStub(stubFor(startSlot), gap);
	const endStub = clampStub(stubFor(endSlot), gap);
	return {
		m: offsetFrom(start, start.direction, startStub),
		l: offsetFrom(end, end.direction, endStub),
		startStub,
		endStub
	};
}
//#endregion
export { clampStub, facingGap, isHorizontal, outwardSign, stubEnds, stubFor };
